import React from 'react';
import { Col, Row } from 'antd';
import { AnotacoesInternas } from '../AnotacoesInternas';

export function TabAnotacoes({
  ultimaAtualizacaoObservacaoInterna,
  setObservacaoInterna,
  observacaoInterna,
}) {
  return (
    <Row
      justify="space-between"
      style={{
        padding: '16px 0',
      }}
    >
      <Col justify="center" md={24} lg={24} xs={24}>
        <AnotacoesInternas
          ultimaAtualizacaoObservacaoInterna={
            ultimaAtualizacaoObservacaoInterna
          }
          setObservacaoInterna={setObservacaoInterna}
          observacaoInterna={observacaoInterna}
        />
      </Col>
    </Row>
  );
}
